import React from 'react';
import { Carousel } from "antd";
import { imageUrl, zeusApp } from '../request/index';
import { useCustomData } from '../pages/context/serviceCustomDataProvider';

const ServiceSwiper: React.FC = () => {
    const contentStyle: React.CSSProperties = {
        margin: 0,
        height: '603px',
        color: '#fff',
        lineHeight: '160px',
        textAlign: 'center',
        background: '#0e08f9',
    };
    const { getValue } = useCustomData();
    const serviceHomeBanner = getValue('serviceHomeBanner');
    console.log(serviceHomeBanner)

    return (
        <div className="about-swiper">
            <div>
                <div style={contentStyle}>
                    <img
                        src={`${imageUrl}${serviceHomeBanner}?zeus-app=${zeusApp}`}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                </div>
            </div>
        </div>
    );
};

export default ServiceSwiper;